/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IncidentsPerUser } from './IncidentsPerUser';
import {
    IncidentsPerUserFromJSON,
    IncidentsPerUserFromJSONTyped,
    IncidentsPerUserToJSON,
    IncidentsPerUserToJSONTyped,
} from './IncidentsPerUser';
import type { IncidentsCharDataPoint } from './IncidentsCharDataPoint';
import {
    IncidentsCharDataPointFromJSON,
    IncidentsCharDataPointFromJSONTyped,
    IncidentsCharDataPointToJSON,
    IncidentsCharDataPointToJSONTyped,
} from './IncidentsCharDataPoint';
import type { IncidentsPerVehicle } from './IncidentsPerVehicle';
import {
    IncidentsPerVehicleFromJSON,
    IncidentsPerVehicleFromJSONTyped,
    IncidentsPerVehicleToJSON,
    IncidentsPerVehicleToJSONTyped,
} from './IncidentsPerVehicle';

/**
 * 
 * @export
 * @interface DashboardSafetyData
 */
export interface DashboardSafetyData {
    /**
     * 
     * @type {Array<IncidentsPerVehicle>}
     * @memberof DashboardSafetyData
     */
    incidentsPerVehicle: Array<IncidentsPerVehicle>;
    /**
     * 
     * @type {Array<IncidentsPerUser>}
     * @memberof DashboardSafetyData
     */
    incidentsPerUser: Array<IncidentsPerUser>;
    /**
     * 
     * @type {Array<IncidentsCharDataPoint>}
     * @memberof DashboardSafetyData
     */
    incidentsChartData: Array<IncidentsCharDataPoint>;
}

/**
 * Check if a given object implements the DashboardSafetyData interface.
 */
export function instanceOfDashboardSafetyData(value: object): value is DashboardSafetyData {
    if (!('incidentsPerVehicle' in value) || value['incidentsPerVehicle'] === undefined) return false;
    if (!('incidentsPerUser' in value) || value['incidentsPerUser'] === undefined) return false;
    if (!('incidentsChartData' in value) || value['incidentsChartData'] === undefined) return false;
    return true;
}

export function DashboardSafetyDataFromJSON(json: any): DashboardSafetyData {
    return DashboardSafetyDataFromJSONTyped(json, false);
}

export function DashboardSafetyDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardSafetyData {
    if (json == null) {
        return json;
    }
    return {
        
        'incidentsPerVehicle': ((json['incidentsPerVehicle'] as Array<any>).map(IncidentsPerVehicleFromJSON)),
        'incidentsPerUser': ((json['incidentsPerUser'] as Array<any>).map(IncidentsPerUserFromJSON)),
        'incidentsChartData': ((json['incidentsChartData'] as Array<any>).map(IncidentsCharDataPointFromJSON)),
    };
}

export function DashboardSafetyDataToJSON(json: any): DashboardSafetyData {
    return DashboardSafetyDataToJSONTyped(json, false);
}

export function DashboardSafetyDataToJSONTyped(value?: DashboardSafetyData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'incidentsPerVehicle': ((value['incidentsPerVehicle'] as Array<any>).map(IncidentsPerVehicleToJSON)),
        'incidentsPerUser': ((value['incidentsPerUser'] as Array<any>).map(IncidentsPerUserToJSON)),
        'incidentsChartData': ((value['incidentsChartData'] as Array<any>).map(IncidentsCharDataPointToJSON)),
    };
}

